<template>
    <div class="d-flex align-items-center justify-content-center mt-4" v-if="totalPage > 1">
        <nav aria-label="Pagination résultat de recherche">
            <ul class="pagination">
                <li class="page-item">
                    <button type="button" class="page-link prev" href="#" @click.prevent=" page > 1 ? changePage(page - 1) : false " :disabled=" page < 2 "><i class="fa-light fa-chevron-left" aria-hidden="true"></i><span class="sr-only">Page précédente</span></button>
                </li>

                <li class="page-item" >
                    <button type="button" class="page-link" v-if="mode === 'show'" @click="toggleInput"><span class="sr-only">Naviguer à la page </span>{{ page }}</button>

                    <input type="text"
                           class="page-link"
                           v-if="mode === 'edit'"
                           ref="input"
                           :value="page"
                           @change="jumpToPage"
                           @keyup="updatePage"
                           @blur="toggleInput" />
                </li>

                <li class="page-item">
                    <button type="button" class="page-link next" href="#" @click.prevent="page < totalPage ? changePage(page + 1) : false" :disabled=" page >=  totalPage "><i class="fa-light fa-chevron-right" aria-hidden="true"></i><span class="sr-only">Page suivante</span></button>
                </li>
            </ul>
        </nav>
        <p class="ms-2">sur {{ totalPage }}</p>
    </div>

</template>

<script setup>

    import { computed, ref } from "vue";
    import { useStore }      from "vuex";
    import { debounce }      from "lodash-es/function";

    //DEFINE
    let props = defineProps(["page", "totalPage"]);
    let emit = defineEmits(["change-page"]);

    //PLUGINS
    let store = useStore();


    //COMPUTED
    let copydeck = computed(() => store.state.copydeck);
    let results = computed( () => store.state.results );
    let iCountResults = computed( () => results.value.length );

    let mode = ref("show")
    let input = ref(null)


    //METHODS
    function changePage (newPage)
    {
        window.scrollTo( {
                             top      :  50,
                             left     : 0,
                             behavior : 'smooth',
                         } );

        if (newPage !== undefined)
        {
            setTimeout(() => emit("change-page", newPage), 500); //ffs (Fix firefox scroll)
        }
    }

    function toggleInput ()
    {
        mode.value = mode.value === "show" ? "edit" : "show";

        if (mode.value === "edit")
        {
            //right now the input is in the shadow DOM
            setTimeout(() => input.value.focus(), 1);
        }
        else
        {

        }
    }

    function updatePage (e)
    {

        let key = e.key;

        if (key.indexOf("Arrow") === 0)
        {
            e.preventDefault();

            let newPage = props.page;

            if (key === "ArrowUp")
            {
                newPage = 1;
            }
            else if (key === "ArrowDown")
            {
                newPage = props.totalPage;
            }
            else if (key === "ArrowLeft")
            {
                if (props.page > 1)
                {
                    newPage = props.page - 1;
                }
            }
            else if (key === "ArrowRight")
            {
                if (props.page < props.totalPage)
                {
                    newPage = props.page + 1;
                }
            }

            changePage(newPage);
            input.value.value = newPage;
            jumpToPage();
            return;
        }


        if (key === "Enter")
        {
            input.value.blur()
            jumpToPage();
            return;
        }


    }

    function jumpToPage ()
    {
        let strValue = input.value.value;

        let iValue = parseInt(strValue);

        if (iValue > 0 && iValue <= props.totalPage)
        {
            changePage(iValue);
            input.value.value = iValue;
        }

    }

</script>

<style scoped>

</style>
